import { createContext } from "react";
export const AccordionContext = createContext({
    headingSize: "small",
    size: "medium",
    openItems: [],
    mounted: false,
});
//# sourceMappingURL=AccordionContext.js.map